import { PointExpression } from 'leaflet';
import { Season } from 'src/app/core/domain/season.enum';
import { WritablePart } from 'src/app/core/utils/type-helper';
import { AssetStatus } from 'src/app/maps/domain/livedata/status.enum';
import { MapElement } from 'src/app/maps/domain/masterdata/map-element.model';
import { MapPosition } from 'src/app/maps/domain/masterdata/map-position.model';
import { SisMapAssetCategory } from 'src/app/maps/domain/masterdata/sismap-asset-category.enum';
import { AssetSubStatus } from '../livedata/substatus.enum';

export class Slope implements MapElement {
  static readonly defaultColor: string = 'black';
  static readonly defaultWeight: number = 2;
  static readonly defaultIconSize: PointExpression = [18, 18];
  static readonly defaultStatusIconSize: PointExpression = [15, 15];

  static readonly empty: Slope = new Slope({ guid: undefined, status: AssetStatus.Closed });

  readonly category = SisMapAssetCategory.Slope;

  guid: string;
  name: string;
  nameEn?: string;
  type: string;
  info?: string;
  website?: string;
  websiteEn?: string;
  season: Season;
  label: string;
  status: AssetStatus;
  path?: string;
  pathDashArray?: string;
  pathWeight?: number;
  pathColor?: string;

  defaultPathColor: string;
  defaultPathWeight: number;

  iconPositions: MapPosition[];
  iconWidth: number;
  iconHeight: number;
  iconImageName?: string;
  iconUseStatus: boolean;

  description: string;
  lengthMeter: number;
  isCategorySki: boolean;
  isGrey: boolean;

  subStatus?: AssetSubStatus | undefined;
  disallowPopUp: boolean;
  disallowHighlight: boolean;
  pathBackgroundColor?: string | undefined;
  iconAlwaysOnTop?: boolean | undefined;
  iconDisableBaseZoom?: boolean | undefined;
  iconSvgBlobName?: string | undefined;
  iconHtml?: string | undefined;
  iconUseMeteoData?: boolean | undefined;
  newlyAdded?: boolean | undefined;

  constructor(init?: Partial<WritablePart<Slope>>) {
    Object.assign(this, init);
    this.isCategorySki ??= false;
    this.isGrey ??= false;
  }
}
